import { Header } from "./Header.";
import Footer from "./Footer";
import "./Styles/legal.css";
import React from "react";
import PageHeader from "./PageHeader";

export const Legal = () => {
  const titleStyle = {
    width: "100%",
    textAlign: "left",
    fontSize: "18px",
    height: "auto",
    color: "#C8437E",
    fontWeight: "bold",
  };

  const containerText = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    rowGap: "5px",
    height: "auto",
    textAlign: 'justify',
    lineHeight: '25px'
  };

  const textContainStyle = {
    width: "100%",
    textAlign: "left",
    height: "auto",
    fontSize: "16px",
    display: "13px",
    color: "black",
    wordBreak: "break-all", //ça arrange le texte mais ça coupe mal les mots, au pire commente la ligne...
  };

  document.title = "Conditions Générales de Vente - KabaaShop";

  const spacingTxt = (
    <>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </>
  );
  return (
    <>
      <Header />
      <PageHeader title={"Conditions Générales de Vente"} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          rowGap: "15px",
          width: "100%",
          height: "auto",
          boxSizing: "border-box",
          padding: "15px 10px",
        }}
        className='legal-container'
      >
        <span
          style={{
            width: "auto",
            textAlign: "center",
            boxSizing: "border-box",
            fontSize: "18px",
            padding: "10px 14px",
            backgroundColor: "#C8437E",
            fontWeight: "bolder",
            color: "white",
          }}
        >
          Conditions Générales de Vente de la boutique KabaaShop
        </span>
        <span style={titleStyle}>ARTICLE 1 - OBJET</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Les présentes conditions générales de vente ont pour objet de déterminer les conditions
            dans lesquelles CHARLES-CHRISTIAN ARMELK. SOMBORN, entrepreneur individuel,
            enregistré au Registre du Commerce de Dakar sous le numéro SN-DKR-2021-E-16066, et
            dont le siège social est situé à Sicap Baobab villa N°799 vend sur Internet kabaashop.com
            ci-après dénommés «les Produits »
            « Il est conseillé à l’Acheteur de conserver et/ou d’imprimer les présentes conditions ».
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 2 : DEFINITIONS</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Dans les présentes CGV, les termes suivants ont, sauf indication contraire, les significations
            qui leur sont données dans cet article :
            <ul>
              <li><strong>Site :</strong> Désigne Le site : www.kabaashop.com qui est une interface client permettant l’achat
                de produits en ligne.</li>
              <li><strong>Service :</strong> Désigne la plateforme accessible sur internet permettant de mettre en ligne et de
                commercialiser les produits en ligne.</li>
              <li><strong>Client :</strong> Désigne une personne physique majeure utilisant le Service, pour ses propres
                besoins, dans le cadre d'une utilisation non commerciale strictement personnelle.</li>
              <li><strong>Terminal :</strong> désigne tout support physique disposant d’une connexion à internet détenu par
                un utilisateur permettant notamment d’accéder au site, pouvant inclure sans que ce soit
                limitatif tout ordinateur, tablette, portables…</li>
            </ul>
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 3 : CONDITIONS PREALABLES</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Le client personne physique, doit être majeur et disposer d’un terminal compatible et d’une
            offre de communication, intégrant des services internet auprès d’un fournisseur de services
            internet souhaiter utiliser les services proposés pour ses propres besoins dans le contexte
            d’une utilisation personnelle, non commerciale.
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 4 : OFFRES PROPOSEES</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Les produits proposés à la vente sont décrits sur le Site.
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 5 : COMMANDES</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Toute commande implique votre acceptation des présentes conditions générales de
            vente. Après avoir consulté l’ensemble des informations disponibles pour effectuer votre
            choix, pour valider votre commande vous devrez préalablement vous identifier.
            Vous êtes informé et acceptez que la saisie de ces informations fasse preuve de votre
            identité et de votre engagement. L’enregistrement de la commande intervient dès la
            validation du paiement par vos soins.
            Le numéro et le récapitulatif de la commande sont affichés à l’écran et envoyés par e-
            mail, à l’adresse électronique préalablement enregistrée.
            Kabaa Shop peut être amenée à vous demander des justificatifs notamment au regard du
            montant de la commande.

            Kabaa Shop se réserve le droit de refuser de fournir le produit prévu, le cas échéant, si
            vous ne remplissez pas les conditions pour en bénéficier.
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 6 : PRIX et DISPONNIBILITE DES PRODUITS</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Les produits et les prix sont valables tant qu’ils sont visibles sur le Site.
            Le prix des produits, qui s’entendent toutes taxes comprises, hors frais de livraison s’il y
            en a, sont ceux en vigueur au moment de votre consultation et validation de commande.
            Les prix sont susceptibles d’être modifiés en fonction de l’évolution de l’offre de produits.
            Des prix spécifiques peuvent être mis en ligne, et sauf indication contraire, sont
            strictement applicables aux seules ventes réalisées sur le Site.
            Exceptionnellement, en cas de difficultés d’approvisionnement, votre commande est mise en
            attente jusqu’à réception de la totalité des produits.
            La commande ne peut donc pas faire l’objet d’une livraison partielle. Vous pouvez suivre
            l’état d’avancement de votre commande dans votre suivi de commande
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 7 : PAIEMENT</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Le client a le choix entre les moyens de paiements suivant : orange money, carte
            bancaire, free money, espèce ou chèque.
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 8 : ERREUR MANIFESTE</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}En cas d’erreur manifeste dans l’affichage du prix de telle sorte que le prix affiché est
            dérisoire ou sans rapport avec la valeur du produit telle qu’habituellement constatée sur le
            marché au moment de la commande, Kabaa Shop peut être amenée à annuler la vente.
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 9 : MONTANTS ET DELAIS DE LIVRAISON</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Le montant de la livraison varie en fonction de la zone où habite le client. Ce montant peut
            varier à tout moment.
            La livraison des produits intervient sous 3 jours ouvrés à compter de la validation de votre
            commande.
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 10 : RETRACTATION</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Vous avez le droit de vous rétracter dans un délai de quinze (15) jours calendaires à compter
            de la date de l’achat du Produit. Le délai court à compter de la date de livraison et expire le
            jour anniversaire de la semaine suivante.
            Si le client a respecté les conditions de rétractation, Kabaa Shop remboursera le paiement
            qu’il aura effectué, y compris les frais de livraison de la commande. Vous recevrez votre
            remboursement dans les 15 jours qui suivent la demande de rétractation.
            Le client perdra le droit de rétractation dans l’un des cas suivants :
            <ul>
              <li>Un élément constituant le produit ne fonctionne plus ;</li>
              <li>Le produit a été ouvert ;</li>
              <li>Il existe un élément manquant du produit ;</li>
              <li>La Boite d’emballage présente une quelconque dégradation (déchirure, déformation,
                présence de tâches) ;</li>
              <li>L’original du Bordereau de livraison est perdu.</li>
            </ul>
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 11 : GARANTIES ET SERVICE APRES-VENTE</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Pour toute information ou réclamation sur les produits le client pourra soit :
            <ul>
              <li>Contacter le service client : <a href="tel:+221779122972">+221779122972</a></li>
              <li>-Nous envoyer un mail à l’adresse suivante :<a href="mailto:info@kabaashop.com"></a></li>
            </ul>
            Kabaa Shop, en tant que vendeur, est tenue des défauts de conformité du produit objet du
            contrat et des défauts cachés de la chose vendue. Conformément aux dispositions relatives
            à la vente.
            Le client devra agir dans un délai raisonnable, il pourra choisir entre la réparation ou le
            remplacement du bien sous réserve des dispositions relatives aux couts.
            Le client peut décider d mettre en œuvre la garantie contre les vices cachés, et ainsi choisir
            entre la résolution de la vente ou une réduction du prix.
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 12 : PREUVE DES TRANSACTIONS</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Les données enregistrées par le système de paiement utilisé et choisi par vous-même
            (établissement bancaire ou autre), constituent la preuve de l’ensemble des transactions
            financières passées sur le Site, vous-même et ledit établissement (ou autre organisme).
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 14 : FORCE MAJEURE</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}La responsabilité de Kabaa Shop ne peut pas être engagée au cas où l’inexécution ou le
            retard dans l’exécution de l’une ou de plusieurs obligations contenues dans le présent
            contrat résulte d’un cas de force majeure.
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 15 : DONNES PERSONNELLES</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Les données à caractère personnel relatives au Client recueillies par KABAA SHOP sont
            traitées dans le cadre de l’exécution des présentes conformément aux dispositions de la loi
            2008-12 du 25 janvier 2008 sur les données à caractère personnel et de la loi n°2008-08 du
            25 janvier 2008 sur les transactions électroniques. Ainsi, tout Client dispose d’un droit
            d’accès, de rectification et d’opposition au traitement des données à caractère personnel le
            concernant en adressant un courrier par écrit quel qu’en soit le support et sans.
            KABAA SHOP pourra utiliser ces données pour la gestion du compte du Client et, le cas
            échéant, pour des opérations de marketing direct, dans les conditions prévues par la
            Délibération n° 2014-20/CDP du 30 mai 2014 sur les conditions de prospection directe, en
            adressant au Client, par quelque support que ce soit, des informations sur ses produits ou
            services.
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 16 : DISPOSITIONS DIVERSES</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Si une ou plusieurs stipulations des présentes CGV sont nulles ou déclarées telles en
            application d’une loi, d’un règlement ou à la suite d’une décision définitive d’une juridiction
            compétente, les autres stipulations garderont toute leur force et leur portée. Les stipulations
            déclarées nulles et non valides seront alors remplacées par des stipulations qui se
            rapprocheront le plus quant à leur contenu des stipulations initialement arrêtées.
          </span>
        </div>

        <span style={titleStyle}>ARTICLE 17 : DROIT APPLICABLE ET REGLEMENT DES DIFFERENDS</span>
        <div style={containerText}>
          <span style={textContainStyle}>
            {spacingTxt}Les présentes CGV sont soumises à la loi sénégalaise. En cas de litige sur les présentes
            clauses, le différend sera porté par la Partie la plus diligente aux tribunaux sénégalais
            territorialement compétents.
          </span>
        </div>

      </div>
      <Footer />
    </>
  );
};
